export default __webpack_public_path__ + "static/media/computer.b740630e.jpg";